export enum QualidadeConexao {
    ALTA = 'Alta qualidade',
    MEDIA = 'Qualidade média',
    BAIXA = 'Baixa qualidade',
    SEM_CONEXAO = 'Sem conexão',
}